<template>
  <div class="chat-interface">
    <!-- 聊天消息区域 -->
    <div class="messages-container" ref="messagesContainer">
      <!-- 欢迎页面 -->
      <div v-if="isWelcome && messages.length === 0">
        <welcome-page v-if="isWelcome && messages.length === 0" @hint-selected="handleHintSelected" />
      </div>

      <!-- 对话消息 -->
      <chat-message v-for="(message, index) in messages" :key="index" :content="message.content"
        :isUser="message.isUser" :timestamp="message.timestamp" :images="message.images || []"
        :diseaseData="message.diseaseData" :cropName="message.cropName" @show-full-image="showImagePreview" />
      <!-- 加载动画 -->
      <div v-if="isLoading" class="loading-animation">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-area">
      <div class="input-container">
        <!-- 样例图片 -->
        <div class="sample-images">
          <div v-for="(image, index) in sampleImages" :key="index" class="sample-image">
            <div class="image-wrapper" @click="handleSampleImage(image)">
              <img :src="image.preview" alt="样例" />
            </div>
            <div class="sample-image-text">
              <p>{{ image.name }}</p>
            </div>
          </div>
        </div>
        <!-- 输入框 -->
        <div class="input-textarea">
          <!-- 上传图片预览 -->
          <div class="image-preview" v-if="uploadedImages.length">
            <div v-for="(image, index) in uploadedImages" :key="index" class="preview-item">
              <img :src="image.preview" alt="预览" />
              <button class="remove-image" @click="removeImage(index)">
                <img src="@/assets/icons/remove.png" alt="" />
              </button>
            </div>
          </div>
          <textarea ref="messageInput" v-model="userMessage"
            placeholder="上传作物图片并描述问题，让AI帮您诊断作物疾病，当前支持番茄、黄瓜、辣椒等75种农作物的615种常见病虫害准确识别。" class="message-input"
            @keydown.enter="sendMessage" @input="adjustTextareaHeight"></textarea>
          <div class="input-actions">
            <!-- <div class="input-actions-left">
              <button @click="toggleDeepThinking" :class="{ 'active': deepThinkingEnabled }">
                <img :src="require(`@/assets/icons/deepthink${deepThinkingEnabled ? '1' : '0'}.png`)" alt="深度思考"
                  class="button-icon" />
                <p>深度思考</p>
              </button>
              <button @click="toggleOnlineSearch" :class="{ 'active': onlineSearchEnabled }">
                <img :src="require(`@/assets/icons/online${onlineSearchEnabled ? '1' : '0'}.png`)" alt="深度思考"
                  class="button-icon" />
                <p>联网搜索</p>
              </button>
            </div> -->
            <div class="input-actions-right">
              <CustomTooltip content="上传图片">
                <button class="upload-button" @click="triggerImageUpload" :disabled="isProcessing">
                  <img src="@/assets/icons/imageUpload.png" alt="">
                </button>
              </CustomTooltip>
              <input type="file" ref="fileInput" accept="image/*" multiple style="display: none"
                @change="handleImageUpload" />
              <CustomTooltip content="清空对话">
                <button class="clear-button" @click="clearInput" :disabled="isProcessing">
                  <img src="@/assets/icons/clear.png" alt="">
                </button>
              </CustomTooltip>
              <CustomTooltip content="发送">
                <button class="send-button" @click="sendMessage" :disabled="!canSendMessage || isProcessing">
                  <img src="@/assets/icons/send.png" alt="">
                </button>
              </CustomTooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div class="image-modal" v-if="previewImage" @click="closeImagePreview">
      <div class="modal-content">
        <img :src="previewImage" alt="预览" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.chat-interface {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 加载动画样式 */
.loading-message {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-animation {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: #249745;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
  vertical-align: middle;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.input-area {
  width: 879px;
  margin: 0 auto 28px;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  max-height: 200px;
  overflow-y: auto;
}

.preview-item {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
}

.preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 14px;
  background-color: transparent;
}

.input-container {
  /* display: flex; */
  background-color: transparent;
  overflow: hidden;

}

.sample-images {
  display: flex;
  flex-wrap: wrap;
  gap: 17px;
  margin-bottom: 10px;
  margin-left: 60px;
  background-color: transparent;
}

.sample-image {
  position: relative;
  width: 75px;
  height: 75px;
  overflow: hidden;
  line-height: 0;
  font-size: 0;
  border-radius: 10px;
  border: 1px solid #249745;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  min-width: 100%;
  min-height: 100%;
}

.sample-image-text {
  /* 文字居中 */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  /* 半透明黑色背景 */
  color: white;
  padding: 4px 2px;
  text-align: center;
  z-index: 2;
  /* 确保文字在图片之上 */

  /* 文字溢出处理 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sample-image-text p {
  width: 24px;
  height: 17px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 17px;
  text-align: right;
  font-style: normal;
}

.input-textarea {
  width: 879px;
  /* height: 144px; */
  border: 1px solid #e0e0e0;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 20px 20px 23px 20px;
}

.message-input {
  width: 100%;
  min-height: 46px;
  max-height: 140px;
  overflow-y: auto;
  border: none;
  resize: none;
  outline: none;
  background-color: transparent;
  font-weight: 400;
  font-size: 16px;
  color: #303030;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.message-input::placeholder {
  color: #9A9A9A;
}

.input-actions {
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 27px;
}

.input-actions-left {
  display: flex;
  flex-direction: row;
  gap: 14px;
}

.input-actions-left button {
  background-color: #FFFFFF;
  width: 90px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #CECECE;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.input-actions-left p {
  font-weight: 400;
  font-size: 12px;
  color: #303030;
  line-height: 17px;
  transition: color 0.2s ease;
}

.input-actions-left button.active {
  border-color: #008626;
}

.input-actions-left button.active p {
  color: #008626;
}

.deepseek-icon {
  width: 14px;
  height: 14px;
}

.upload-button,
.clear-button {
  margin-right: 20px;
  border: none;
  background-color: transparent;
}

.upload-button img,
.clear-button img {
  width: 18px;
  height: 18px;
}



.send-button {
  padding: 8px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 4px;
}

.upload-button:hover,
.send-button:hover {
  background-color: #e0e0e0;
}

.send-button {
  margin-top: auto;
  width: 36px;
  height: 36px;
  background: rgba(21, 128, 61, 0.09);
  border-radius: 50%;
}

.send-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.input-tips {
  margin-top: 8px;
  text-align: right;
  font-size: 12px;
  color: #999;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  max-width: 90%;
  max-height: 90%;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.button-icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  vertical-align: middle;
}

.el-button.active {
  background-color: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.crop-options {
  margin-top: 10px;
}

.option-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.crop-button {
  padding: 6px 12px;
  background-color: #249745;
  color: white;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.crop-button:hover {
  background-color: #1b7035;
}
</style>

<script>
import WelcomePage from './WelcomePage.vue';
import ChatMessage from './ChatMessage.vue';
import CustomTooltip from '@/components/CustomTooltip.vue';
// 导入两个API函数
import { predictDisease, cropDiagnosis } from '@/api/chat.js';

export default {
  name: 'ChatInterface',
  components: {
    ChatMessage,
    WelcomePage,
    CustomTooltip
  },
  data() {
    return {
      isLoading: false,
      diseaseData: {
        diseaseName: '',
        confidences: [],
        description: '',
        feature: '',
        method: '',
      },
      // 默认为true,有对话后变为false
      isWelcome: true,
      messages: [],
      userMessage: '',
      uploadedImages: [],
      previewImage: null,
      isProcessing: false,
      defaultCrop: '',
      deepThinkingEnabled: false,
      onlineSearchEnabled: false,
      sampleImages: [
        {
          preview: require('@/assets/image/testImage/corn/5.jpg'),
          name: '玉米'
        },
        {
          preview: require('@/assets/image/testImage/cotton/tjb.jpg'),
          name: '棉花'
        },
        {
          preview: require('@/assets/image/testImage/pepper/IMG20220630093646.jpg'),
          name: '辣椒'
        },
        {
          preview: require('@/assets/image/testImage/peony/peony.png'),
          name: '牡丹'
        },
        {
          preview: require('@/assets/image/testImage/rice/健康.jpg'),
          name: '水稻'
        },
        {
          preview: require('@/assets/image/testImage/tomato/2022-03-08 115305.jpg'),
          name: '番茄'
        },
        {
          preview: require('@/assets/image/testImage/wheat/叶锈病.jpg'),
          name: '小麦'
        }
      ],
      supportedCrops: ['番茄', '黄瓜', '苹果', '水稻', '葱', '大豆', '辣椒', '柑橘', '玉米']
    }
  },
  created() {
    // 示例数据用于测试
  },
  computed: {
    canSendMessage() {
      return (this.userMessage.trim() || this.uploadedImages.length > 0);
    }
  },
  mounted() {
    // 初始化时不添加消息，保持欢迎页显示
  },
  methods: {
    handleHintSelected(title) {
      // 自动填充输入框
      this.userMessage = title;
      // 立即发送请求
      this.$nextTick(() => {
        this.sendMessage();
      });
    },
    async handleSampleImage(image) {
      this.isLoading = true;
      try {
        // 获取图片二进制数据
        const response = await fetch(image.preview)
        if (!response.ok) throw new Error(`HTTP错误 ${response.status}`)

        // 生成Blob URL
        const blob = await response.blob()
        const imageUrl = URL.createObjectURL(blob)

        // 如果是棉花图片，显示模拟数据
        if (image.name === '棉花') {
          // 创建模拟的棉花炭疽病数据
          const mockCottonResult = {
            cropName: '棉花',
            data: {
              data: [{
                label: '炭疽病',
                confidences: [{
                  label: '炭疽病',
                  confidence: 0.95 // 95%的置信度，对应"极大概率"
                }]
              }]
            },
            feature: '病斑初呈圆形或近圆形，颜色为黄褐色至深褐色，边缘清晰；病斑中央凹陷，有时呈现同心轮纹状；叶片严重感病时出现穿孔现象，果实受害后出现深陷的黑色病斑；高温高湿条件下病害发展迅速，雨后传播加剧。',
            physics: '- 选择排水良好的田块，避免积水造成的高湿环境\n- 合理密植，保证田间通风透光，降低湿度\n- 及时清除病残体，减少病原菌越冬场所\n- 实行轮作制度，与非茄科作物轮作2-3年\n- 雨后及时排水，减少田间湿度',
            chemistry: '- 发病初期喷施甲基硫菌灵或多菌灵进行预防\n- 使用咪鲜胺、苯醚甲环唑等三唑类杀菌剂治疗\n- 严重时可用氟环唑、丙环唑等内吸性杀菌剂\n- 每10-15天喷药一次，连续2-3次\n- 雨前雨后及时补喷，确保药效持续',
            biology: '- 应用枯草芽孢杆菌等生物制剂进行土壤处理\n- 喷施木霉菌制剂抑制病原菌生长繁殖\n- 使用放线菌提取物增强植株抗病能力\n- 施用微生物有机肥改善土壤微生态环境\n- 叶面喷施海藻提取物等生物刺激素'
          };

          // 在对话框中显示棉花炭疽病结果
          this.addMessage('', false, [imageUrl], mockCottonResult);
          this.isLoading = false;
          return;
        }

        // 如果是牡丹图片，显示模拟数据
        if (image.name === '牡丹') {
          // 创建模拟的牡丹缺铁黄叶病数据
          const mockPeonyResult = {
            cropName: '牡丹',
            data: {
              data: [{
                label: '缺铁黄叶病',
                confidences: [{
                  label: '缺铁黄叶病',
                  confidence: 0.88 // 88%的置信度，对应"大概率"
                }]
              }]
            },
            feature: '叶片从叶脉间开始发黄，逐渐扩展至整个叶片，叶脉仍保持绿色，形成典型的网状花纹；严重时叶片边缘出现褐色焦枯，甚至脱落；新叶比老叶症状更明显，植株生长势减弱，开花质量下降。',
            physics: '- 彻底清除病残落叶，剪除茎基部病残枝，集中烧毁或深埋\n- 检测土壤pH值，增施有机肥改善土壤结构，降低土壤碱性\n- 适当密植，防止湿气滞留，雨后及时排水避免积水\n- 设置遮荫物，避免阳光直射，减少水分蒸发和铁元素流失\n- 合理控制土壤酸碱度，保持pH值在7.3以下',
            chemistry: '- 每平方米施用硫酸亚铁50-100克或硫磺粉30-50克调节土壤酸碱度\n- 喷施0.1%-0.3%硫酸亚铁溶液，每隔7-10天一次，连续2-3次\n- 使用含铁螯合物如EDTA铁等，稳定性和吸收率更高\n- 施用过磷酸钙、磷酸二铵等生理酸性肥料降低土壤碱性\n- 避免过量使用，防止土壤酸度过高影响牡丹生长',
            biology: '- 增施含腐殖酸的有机肥，每亩施用1000-2000公斤有机肥\n- 施用含有益微生物的生物菌肥，如5406抗生菌菌种粉\n- 有机肥中掺入适量硫酸亚铁，提高铁元素有效性\n- 利用微生物与根系共生关系，促进铁元素吸收\n- 改善土壤结构，增强土壤肥力，提高植株抗病能力'
          };

          // 在对话框中显示牡丹缺铁黄叶病结果
          this.addMessage('', false, [imageUrl], mockPeonyResult);
          this.isLoading = false;
          return;
        }

        // 其他图片调用真实的诊断接口
        const imageFile = new File([blob], `${image.name}.jpg`, { type: 'image/jpeg' })
        const result = await predictDisease(imageFile, image.name)

        // 传递生成的Blob URL
        this.addMessage('', false, [imageUrl], result)
        // 等待前面语句全部执行完再执行this.isLoading = false
        this.$nextTick(() => {
          this.isLoading = false;
        })

      } catch (error) {
        console.error('样例图片处理失败:', error)
        this.addMessage(`加载失败: ${error.message}`, false)
        this.isLoading = false;
      } finally {
        this.isProcessing = false;
      }
    },

    // 处理诊断响应的方法
   async handleDiagnosticResponse(response, imageBlob, cropName, imageUrl) {
      const { type, content, crop } = response;

      switch (type) {
        case 'image':
          if (crop) {
            const cropOptions = crop.split(' ').filter(Boolean);
            if (cropOptions.length > 0) {
              // 创建一个包含作物选项按钮的消息内容
              let optionsHtml = '<div class="crop-options"><p>请选择作物类型，如果不存在，请直接输入</p><div class="option-buttons">';
              
              cropOptions.forEach(crop => {
                optionsHtml += `<button class="crop-button" data-crop="${crop}">${crop}</button>`;
              });
    
              optionsHtml += '</div></div>';
              
              this.addMessage(`${content}\n${optionsHtml}`, false);
              
              const estimatedRenderTime = content.length * 25 + 500; // 预估时间，增加500ms缓冲
              await new Promise(resolve => setTimeout(resolve, estimatedRenderTime));
            
              const maxAttempts = 10; // 最大尝试次数
              let attempts = 0;
              
              const checkInterval = setInterval(() => {
                const buttons = document.querySelectorAll('div.message-body button');
                if (buttons.length > 0) {
                  // 按钮已渲染，清除检查间隔
                  clearInterval(checkInterval);
                  // 添加事件监听器
                  this.showCropOptions(imageBlob, imageUrl);
                } else if (++attempts >= maxAttempts) {
                  // 超过最大尝试次数，放弃
                  clearInterval(checkInterval);
                  console.warn('无法找到作物选择按钮，可能由于流式渲染导致');
                }
              }, 300); // 每300毫秒检查一次
            } else {
              this.addMessage(content, false);
            }
          } else {
            this.addMessage(content, false);
          }

          this.isLoading = false;

          break;

        case 'predict':
          // 需要调用专业模型进行分析
          if (imageBlob) {
            try {
              // 使用返回的作物名称和原始图片调用predictDisease
              const imageFile = new File([imageBlob], `${cropName}.jpg`, { type: 'image/jpeg' });
              const result = await predictDisease(imageFile, crop || cropName);
              this.addMessage(content, false, imageUrl ? [imageUrl] : [], result);
              this.isLoading = false;
            } catch (error) {
              console.error('专业分析失败:', error);
              this.addMessage(`专业分析请求失败: ${error.message}`, false);
              this.isLoading = false;
            }
          } else {
            // 没有图片的情况，只能显示初步分析结果
            this.addMessage(`${content}（无法进行专业分析，请上传图片）`, false);
            this.isLoading = false;
          }
          break;

        case 'error':
          // 错误信息，直接显示
          this.addMessage(content, false);
          this.isLoading = false;
          break;

        case 'answer':
          // 直接回答内容，显示
          this.addMessage(content, false);
          this.isLoading = false;
          break;

        default:
          // 未知类型，显示原始内容
          this.addMessage('收到未知类型的响应：' + content, false);
          this.isLoading = false;
      }
    },

    showCropOptions(imageBlob, imageUrl) {            
      // 在nextTick中添加事件监听器
      this.$nextTick(() => {
        const buttons = document.querySelectorAll('div.message-body button');
        buttons.forEach(button => {
          button.addEventListener('click', async () => {
            const selectedCrop = button.getAttribute('data-crop');
            this.isLoading = true;
            
            try {
              // 创建File对象并调用预测
              if (imageBlob) {
                const imageFile = new File([imageBlob], `${selectedCrop}.jpg`, { type: 'image/jpeg' });
                const result = await predictDisease(imageFile, selectedCrop);
                this.addMessage('', false, imageUrl ? [imageUrl] : [], result);
              }
            } catch (error) {
              console.error('作物预测失败:', error);
              this.addMessage(`作物预测失败: ${error.message}`, false);
            } finally {
              this.isLoading = false;
            }
          });
        });
      });
    },

    toggleDeepThinking() {
      this.deepThinkingEnabled = !this.deepThinkingEnabled;
      console.log('深度思考模式:', this.deepThinkingEnabled ? '开启' : '关闭');
    },
    toggleOnlineSearch() {
      this.onlineSearchEnabled = !this.onlineSearchEnabled;
      console.log('联网搜索模式:', this.onlineSearchEnabled ? '开启' : '关闭');
    },

    addMessage(content, isUser, images = [], diseaseData = null, cropName = null) {
      // 添加消息时将isWelcome设置为false
      this.isWelcome = false;

      this.messages.push({
        content,
        isUser,
        timestamp: Date.now(),
        images,
        diseaseData,
        cropName
      });

      // 等待DOM更新后再滚动
      this.$nextTick(() => {
        setTimeout(() => {
          // 用户发送消息时立即滚动到底部，AI回复时滚动到新消息顶部
          if (isUser) {
            const container = this.$refs.messagesContainer;
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          } else {
            this.scrollToBottom();
          }
        }, 100); // 添加小延时确保内容完全渲染
      });
    },

    // 将图片转换为Base64格式并压缩
    async imageToBase64(imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        
        // 创建图片对象进行压缩
        const img = new Image();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        return new Promise((resolve, reject) => {
          img.onload = () => {
            // 设置压缩参数
            const maxPixels = 1000000; // 100万像素
            const maxBytes = 8 * 1024 * 1024; // 8MB
            let quality = 0.85;
            
            // 计算当前像素数
            const currentPixels = img.width * img.height;
            
            // 如果像素数超过限制，按比例缩放
            let { width, height } = img;
            if (currentPixels > maxPixels) {
              const scaleFactor = Math.sqrt(maxPixels / currentPixels);
              width = Math.floor(img.width * scaleFactor);
              height = Math.floor(img.height * scaleFactor);
            }
            
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            
            // 尝试不同质量级别直到满足大小要求
            const tryCompress = (q) => {
              const dataUrl = canvas.toDataURL('image/jpeg', q);
              const base64Length = dataUrl.length * 0.75; // base64大小估算
              
              if (base64Length <= maxBytes || q <= 0.3) {
                resolve(dataUrl);
              } else {
                tryCompress(q - 0.1);
              }
            };
            
            tryCompress(quality);
          };
          
          img.onerror = reject;
          img.src = URL.createObjectURL(blob);
        });
      } catch (error) {
        console.error('图片转Base64失败:', error);
        return null;
      }
    },

    async sendMessage() {
      if (!this.canSendMessage || this.isProcessing) return;

      this.isLoading = true;
      const messageText = this.userMessage.trim();
      const imageUrls = this.uploadedImages.map(img => img.preview);

      // 添加用户消息
      this.addMessage(messageText, true, imageUrls);

      this.isProcessing = true;
      try {
        // 准备对话历史数据
        const history = [];

        // {
        //   role: "user",
        //   content: []
        // }

        for (const message of this.messages) {
          // 压缩图片数据 - 如果是blob URL则转换为base64并压缩
          if (message.images && message.images.length > 0) {
            for (let i = 0; i < message.images.length; i++) {
              if (message.images[i] && message.images[i].includes('blob:')) {
                message.images[i] = await this.imageToBase64(message.images[i]);
              }
            }
          }
          
          if (message.isUser) {
            let content = [];
            
            // 添加文本内容
            if (message.content) {
              content.push({
                type: "text",
                text: message.content
              });
            }
            
            // 添加所有图片内容
            if (message.images && message.images.length > 0) {
              for (const imageUrl of message.images) {
                content.push({
                  type: "image_url",
                  image_url: {
                    url: imageUrl
                  }
                });
              }
            }
            
            if (content.length > 0) {
              history.push({
                role: "user",
                content: content
              });
            }

          } else {
            if (message.content) {
             history.push({
                role: "assistant",
                content: [
                  {
                    type: "text",
                    text: message.content
                  }
                ]
              }); 
            }
          }
        }

        const diagnosticResult = await cropDiagnosis(history);

        // 添加图片内容
        if (this.uploadedImages.length > 0) {
          await this.handleDiagnosticResponse(
            diagnosticResult,
            this.uploadedImages[0].file,
            messageText,
            this.uploadedImages.map(img => img.preview)
          );
        } else {
          // 使用同样的响应处理逻辑
          await this.handleDiagnosticResponse(diagnosticResult, null, messageText, null).then(() => {
            this.isLoading = false;
          });
        }
      } catch (error) {
        console.error('对话请求失败:', error);
        this.addMessage(`请求失败: ${error.message || '网络错误'}，请稍后重试。`, false);
        this.isLoading = false;
      } finally {
        // 清空输入
        this.userMessage = '';
        this.uploadedImages = [];
        this.isProcessing = false;

        // 重置文本框高度
        this.$nextTick(() => {
          this.adjustTextareaHeight();
        });
      }
    },

    triggerImageUpload() {
      if (this.isProcessing) return
      this.$refs.fileInput.click();
    },
    handleImageUpload(event) {
      const files = event.target.files;

      if (!files.length) return;

      // 更新限制：最多支持10张图片
      const maxImages = 10;
      if (this.uploadedImages.length + files.length > maxImages) {
        alert(`最多只能上传${maxImages}张图片`);
        return;
      }

      Array.from(files).forEach(async file => {
        if (!file.type.startsWith('image/')) {
          alert('请上传图片文件');
          return;
        }

        try {
          // 读取文件为ArrayBuffer然后转换为Blob
          const arrayBuffer = await file.arrayBuffer();
          const blob = new Blob([arrayBuffer], { type: file.type });
          
          // 使用压缩函数
          const compressedBase64 = await this.compressImageFile(blob);
          
          this.uploadedImages.push({
            file,
            preview: compressedBase64
          });
        } catch (error) {
          console.error('图片压缩失败，使用原图:', error);
          // 如果压缩失败，使用原始FileReader方法
          const reader = new FileReader();
          reader.onload = e => {
            this.uploadedImages.push({
              file,
              preview: e.target.result
            });
          };
          reader.readAsDataURL(file);
        }
      });

      // 清空input，允许重复选择相同文件
      event.target.value = '';
    },

    // 压缩图片文件
    async compressImageFile(blob) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        img.onload = () => {
          // 设置压缩参数
          const maxPixels = 1000000; // 100万像素
          const maxBytes = 8 * 1024 * 1024; // 8MB
          let quality = 0.85;
          
          // 计算当前像素数
          const currentPixels = img.width * img.height;
          
          // 如果像素数超过限制，按比例缩放
          let { width, height } = img;
          if (currentPixels > maxPixels) {
            const scaleFactor = Math.sqrt(maxPixels / currentPixels);
            width = Math.floor(img.width * scaleFactor);
            height = Math.floor(img.height * scaleFactor);
          }
          
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          
          // 尝试不同质量级别直到满足大小要求
          const tryCompress = (q) => {
            const dataUrl = canvas.toDataURL('image/jpeg', q);
            const base64Length = dataUrl.length * 0.75; // base64大小估算
            
            if (base64Length <= maxBytes || q <= 0.3) {
              resolve(dataUrl);
            } else {
              tryCompress(q - 0.1);
            }
          };
          
          tryCompress(quality);
        };
        
        img.onerror = reject;
        img.src = URL.createObjectURL(blob);
      });
    },
    // 清空对话并初始化到欢迎页
    clearInput() {
      if (this.isProcessing) return
      this.messages = [];
      this.userMessage = '';
      this.uploadedImages = [];
      // 重置isWelcome为true，返回到欢迎页
      this.isWelcome = true;
      this.deepThinkingEnabled = false;
      this.onlineSearchEnabled = false;

      // 重置文本框高度
      this.$nextTick(() => {
        this.adjustTextareaHeight();
      });

      console.log('对话已清空，欢迎页已显示');
    },
    removeImage(index) {
      this.uploadedImages.splice(index, 1);
    },
    showImagePreview(imageUrl) {
      this.previewImage = imageUrl;
    },
    closeImagePreview() {
      this.previewImage = null;
    },
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (!container) return;
      
      // 获取最后一条消息元素
      const messages = container.getElementsByClassName('message-container');
      const lastMessage = messages[messages.length - 1];
      
      if (lastMessage) {
        // 使用平滑滚动效果
        lastMessage.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'  // 滚动到消息顶部
        });
      }
    },
    // 添加新方法用于调整文本框高度
    adjustTextareaHeight() {
      const textarea = this.$refs.messageInput;

      // 重置高度以便正确计算
      textarea.style.height = 'auto';

      // 计算新高度，但不超过140px
      const newHeight = Math.min(textarea.scrollHeight, 140);
      textarea.style.height = newHeight + 'px';
    }
  }
}
</script>